import { useEffect } from "react";

import useFileImportStore from "../../../stores/fileImportStore";

export default function useSetCurrentBOMData() {
  const currentIndex = useFileImportStore((s) => s.currentIndex);
  const unparsedBOMs = useFileImportStore((s) => s.unparsedBOMs);

  useEffect(() => {
    if (unparsedBOMs && Array.isArray(unparsedBOMs)) {
      useFileImportStore.getState().setCurrentUnparsedBOM(unparsedBOMs[currentIndex]);
    }
  }, [currentIndex, unparsedBOMs]);
}
